<template>
  <el-dialog :visible.sync="dialogVisible" @close="handleClose" width="600px">
    <span slot="title" style="color: #fff;font-size: 14px;">批量设置搜索推荐图 <el-tag type="info" size="mini" effect="dark" style="margin-left: 12px;">针对所有sku</el-tag></span>
    <el-form label-width="100px">
      <el-form-item label="搜索推荐图：">
        <ImgUpload
          ref="imgUploadRef"
          :file="imageUrl"
          :isSingle="true"
          v-bind="imageLimits"
          @upload-success="handleChange"
          @del="handleChange"
        />
        <div class="tips">
          图片大小不超过3M，尺寸至少为480px*640px、至多为1125px*1500px，比例{{sstjggCat == 1 ? '1:1' : '3:4'}}，仅支持jpeg、jpg、png格式
          <el-link href="https://mtt.jd.com/article/articleView/cecba5c4-9610-4fd7-8370-02fee2eb95f0" target="_blank">【点击查看平台通知】</el-link>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import ImgUpload from '@/components/Uploads/ImgUpload';

export default {
  components: {
    ImgUpload,
  },
  props: {
    imageLimits: {
      type: Object,
      default: () => {},
    },
    sstjggCat: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      dialogVisible: false,
      opts: {},
      row: {},
      imageUrl: '',
    };
  },
  methods: {
    method_open(opts) {
      this.dialogVisible = true;
      this.opts = opts;
    },
    async handleConfirm() {
      if (!this.imageUrl) {
        this.$message.error('请上传搜索推荐图');
        return;
      }
      let errMsg = await this.$refs.imgUploadRef.method_validImage();
      if (errMsg) {
        this.$message.error(errMsg);
        return;
      }
      this.opts.sureFn && this.opts.sureFn(this.imageUrl);
      this.handleClose();
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data());
      this.dialogVisible = false;
    },
    handleChange(url) {
      this.imageUrl = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  color: #9ca7b6;
  font-size: 12px;
  margin: 10px 0px
}
</style>
